import styled from 'styled-components';

const PhotoHeader = styled.div`
    position: absolute;
    bottom: 25px;
    width: auto;
    border-left: 4px solid #FF0000;
    background: #fff;
    line-height: 30px;
    span {
        display: inline-block;
        background: #fff;
        padding: 6px 12px 2px;
        color: #000;
        font-family: 'Roboto', sans-serif;
        font-size: 3rem;
        font-weight: 700;
        font-style: italic;
    }
    @media (max-width: 700px) {
        position: relative;
        bottom: 0;
        padding: 10px 5px;
        line-height: 25px;
        span {
          padding: 0 10px 0;
          font-size: 1.8rem;
        }
    }
`;
 


export default PhotoHeader;